module.exports = __webpack_public_path__ + "static/media/preset_matte.e1c94061.jpg";